import { Box, Stack, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

export default function ImagesDetails({ images, data }) {
  const theme = useTheme();
  const [mainImage, setMainImage] = useState();

  useEffect(() => {
    setMainImage(images?.[0]);
  }, [images]);

  const isMediumDown = useMediaQuery(theme.breakpoints.down("sm"));

  const sliderSlides = images?.map((item, index) => {
    const isActive = mainImage?.file_name === item?.file_name;

    return (
      <SwiperSlide
        key={index}
        style={{ cursor: "pointer" }}
        onClick={() => setMainImage(item)}
      >
        <Box
          sx={{
            width: { xs: "70px", lg: "85px", exl: "100px" },
            height: { xs: "70px", lg: "85px", exl: "100px" },
            borderRadius: "14px",
            overflow: "hidden",
            backgroundColor: "rgba(0,0,0,0.2)",
            border: isActive
              ? `1px solid ${theme.palette.primary.main}`
              : "1px solid rgba(255,255,255,0.05)",
            transition: "all 0.3s cubic-bezier(0.2, 0.8, 0.2, 1)",
            boxShadow: isActive
              ? `0 0 10px ${theme.palette.primary.lowOpacity}`
              : "none",
            "&:hover": {
              borderColor: theme.palette.primary.lowOpacity,
              transform: "translateY(-2px)",
            },
          }}
        >
          <img
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain", // Prevents image cut-off
              borderRadius: "inherit", // Explicit border radius for the image
              // padding: "6px", // Adds breathing room
            }}
            src={import.meta.env.VITE_URL + item?.file_name}
            title={item?.title}
            alt={item?.alt}
          />
        </Box>
      </SwiperSlide>
    );
  });

  return (
    <Stack sx={{ gap: 2 }}>
      <Stack
        sx={{
          height: { xs: "280px", sm: "380px", lg: "420px", xxl: "500px" },
          width: "100%",
          borderRadius: "28px",
          position: "relative",
          backgroundColor: "rgba(255, 255, 255, 0.02)",
          backdropFilter: "blur(20px)",
          border: "1px solid rgba(255, 255, 255, 0.04)",
          boxShadow: "0 15px 40px rgba(0,0,0,0.2)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(135deg, rgba(255,255,255,0.03) 0%, transparent 50%, rgba(0,0,0,0.1) 100%)",
            borderRadius: "inherit",
            zIndex: 1,
            pointerEvents: "none",
          }}
        />

        <img
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            borderRadius: "inherit", // Explicitly applying border radius to image
            padding: "1rem", // Prevents main image cut-off on edges
            zIndex: 2,
            filter: "drop-shadow(0 10px 20px rgba(0,0,0,0.3))",
          }}
          src={
            mainImage?.file_name
              ? import.meta.env.VITE_URL + mainImage?.file_name
              : "/Media/nimobileIcon.png"
          }
          alt={mainImage?.alt || "تصویر"}
        />
      </Stack>

      <Stack width="100%" height={{ xs: "90px", xl: "120px" }}>
        <Swiper
          spaceBetween={12}
          slidesPerView={isMediumDown ? 3.5 : 4.5}
          style={{
            width: "100%",
            height: "100%",
            direction: "rtl",
            padding: "8px 0",
          }}
        >
          {sliderSlides}
        </Swiper>
      </Stack>
    </Stack>
  );
}
